import { createSlice } from "@reduxjs/toolkit";

import { HomeAPI } from "../../services/home";

const Home = createSlice({
  name: "Home slice",
  initialState: {
    list: [],
    oneHomeBanner: null,
    total: 0,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(HomeAPI.getHomeBanners.fulfilled, (state, action) => {
        const { home_banners, total } = action.payload;

        state.list = home_banners;
        state.total = total;
      })

      .addCase(HomeAPI.getOneHomeBanner.fulfilled, (state, action) => {
        state.oneHomeBanner = action.payload;
      });
  },
});

export default Home;
